import React from 'react'
import FormROValue from '../../../library/form/components/FormROValue1';
import DocRowContainer from "../DocRowContainer"
import DocChildActivator from "../DocChildActivator"
import SarasLogTrans from '../../../library/translation/SarasLogTrans';

const DocLogRow = (props) => {
    const { formObject, rowKey } = props;
    const messageData = formObject.getFormData(rowKey, undefined, "message");

    return (
        <li className='uiDivider'>
            <DocRowContainer formObject={formObject} rowKey={rowKey} 
                containerClass="uiSpacer5 uiBoxHiddenAction" 
                actionClass="uiActionBlock">
                <div>
                    <div>
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "loggedBy" }} className="uiSpacerH5 uiBlue uiUnHighlight" />
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "logTime" }} className="uiSpacerH5 uiGrey uiUnHighlight" />
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "status" }} className="uiGrey uiUnHighlight" />
                        <FormROValue format="hhmm" formObject={formObject} rowKey={rowKey} action={{ paramName: "timeSpent" }} className="uiGrey uiSpacerH5 uiHighlightBlue" />
                    </div>
                    <FormROValue customWrapper="div" format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "title" }} className="uiSpacerH5 uiSecondary" />
                    <div className="uiSpacerH5">
                        <SarasLogTrans value={messageData?.val || ''} transObject={messageData?.dataList?.transObject || ''} />
                    </div>
                    <div className="uiSpacerH5 uiSpacer5">
                        <DocChildActivator formObject={formObject} headerKey="childComp"
                            action={{ actionId: "show",  actionParam: {}, containerKey: "popup" }}
                        />
                    </div>
                </div>
            </DocRowContainer>
        </li>
    )
}

export default DocLogRow
